/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetPipelineHealthQueryResponse, IngestionStatusControllerGetPipelineHealthQueryParams, IngestionStatusControllerGetPipelineHealth403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetPipelineHealth";

function getIngestionStatusControllerGetPipelineHealthUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/ingestion-status/pipeline` as const }  
  return res
}

/**
 * @description Returns a comprehensive view of the entire ingestion pipeline health, showing how files flow through to documents and intelligence processing. Includes orphaned items, stuck processes, and alerts. Requires System Administrator role.
 * @summary Get holistic pipeline health
 * {@link /api/v1/documents/ingestion-status/pipeline}
 */
export async function ingestionStatusControllerGetPipelineHealth(params?: IngestionStatusControllerGetPipelineHealthQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IngestionStatusControllerGetPipelineHealthQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetPipelineHealth403>, unknown>({ method : "GET", url : getIngestionStatusControllerGetPipelineHealthUrl().url.toString(), params, ... requestConfig })  
  return res.data
}